import script from "./NoticiasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiasCard.vue?vue&type=script&setup=true&lang=js"

import "./NoticiasCard.vue?vue&type=style&index=0&id=1fa63254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa63254"]])

export default __exports__